import { render, staticRenderFns } from "./DocumentFileAddEditModal.vue?vue&type=template&id=36d8a3b3&scoped=true&"
import script from "./DocumentFileAddEditModal.vue?vue&type=script&lang=js&"
export * from "./DocumentFileAddEditModal.vue?vue&type=script&lang=js&"
import style0 from "./DocumentFileAddEditModal.vue?vue&type=style&index=0&id=36d8a3b3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d8a3b3",
  null
  
)

export default component.exports